import ApplicationRating from '@apps/ApplicationRating'
import { F_RATING_SYSTEM } from '@common/featureFlags/access'
import CheckAccess from '@common/featureFlags/CheckAccess'
import { useAppSelector, useTranslate } from '@common/hooks'
import Footer from '@layouts/Footer'
import cx from 'classnames'
import { useRouter } from 'next/router'

import classNames from './styles.module.scss'


interface IProps {
  children: React.ReactNode,
}

export default function ApplicationTabs({
  children,
}: IProps): JSX.Element {
  const router = useRouter()

  const { translate } = useTranslate()
  const application = useAppSelector(store => store.application?.data) as IApplication

  const handleChangeTab = (url: string) => () => {
    void router.push(url, undefined, { shallow: true })
  }

  const tab = router.asPath.split('?')[0]

  return (
    <section className={classNames.tabs}>
      <header className={classNames.header}>
        <button
          data-test="details-tab"
          className={cx(classNames.tab, tab.endsWith('settings') && classNames.active)}
          onClick={handleChangeTab(`/apps/${application.slug || application.id}/settings`)}
        >
          {translate('Details')}
        </button>
        <CheckAccess
          access={F_RATING_SYSTEM}
        >
          <button
            data-test="reviews-tab"
            className={cx(classNames.tab, tab.endsWith('reviews') && classNames.active)}
            onClick={handleChangeTab(`/apps/${application.slug || application.id}/reviews`)}
          >
            {translate('Reviews')}
          </button>
        </CheckAccess>
      </header>
      {tab.endsWith('settings') && children}
      {tab.endsWith('reviews') && <>
        <ApplicationRating/>
        <Footer />
      </>
      }
    </section>
  )
}
